import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import type { EventEmitter } from "@/domains/library"
import { claimClFarmReward } from "@/domains/on-chain"

export type ClaimClFarmRewardInteractionParams = {
  account: Address
  chainId: number
  config: Config
  voterAddress: Address
  farmAddress: Address
  earnedAddresses: Address[]
  pairDisplayName: string
  emitter: EventEmitter<EmitEvent>
}

export const claimClFarmRewardInteraction = async ({
  account,
  chainId,
  config,
  voterAddress,
  farmAddress,
  earnedAddresses,
  pairDisplayName,
  emitter,
}: ClaimClFarmRewardInteractionParams) => {
  if (!account) {
    return emitter.emit("error-not-connected", {
      title: "Not connected",
      description: "In order to interact with this app, you first must connect your wallet.",
      variant: "error",
    })
  }

  emitter.emit("claiming-cl-farm-rewards", {
    title: "Claiming CL farm rewards",
    description: `Claiming rewards for ${pairDisplayName}`,
    variant: "info",
  })

  const result = await claimClFarmReward({
    account,
    chainId,
    config,
    voterAddress,
    farmAddress,
    earnedAddresses,
    tokenId: 0,
  })

  if (result.success === true) {
    emitter.emit("claimed-cl-farm-rewards", {
      title: "Claim CL farm rewards",
      description: `Claimed rewards for ${pairDisplayName}`,
      variant: "success",
    })
    return result
  }

  emitter.emit("error-claiming-cl-farm-rewards", {
    title: "Claim CL farm rewards",
    description: result.error,
    variant: "error",
  })

  return false
}
